import React from 'react';

/** @internal */
export var chevronRightIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "10",
  height: "17",
  viewBox: "0 0 10 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5 15.5L8.5 8.48908L1.5 1.5",
  strokeWidth: "1.5",
  strokeLinecap: "round"
}));